import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=7fa1ed3a&scoped=true&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wallet.vue?vue&type=style&index=1&id=7fa1ed3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1ed3a",
  null
  
)

export default component.exports